export enum GroupStatus {
    UN_DETERMINED = 0,
    DETERMINED
}

const groupStatus = {
    [GroupStatus.UN_DETERMINED]: '待确认',
    [GroupStatus.DETERMINED]: '已确认'
}

export const getGroupStatus = (gs: GroupStatus) => groupStatus[gs] || '';